export default __webpack_public_path__ + "static/media/pt-logo-header.cb1a7cd8.svg";